<img src="/assets/images/usage-limits/properties.svg" alt="text and photo fields illustration" />
<h1 class="sm-text-xl sm-font-bold" data-test="title" i18n>Unlock more properties!</h1>
<p class="sm-text-center" i18n data-test="subtitle">{{ upgradePlanText }}</p>

<section class="sm-flex sm-space-y-2 sm-flex-col sm-self-stretch">
  <button type="button" class="cta-button intercom-button" (click)="openLiveChat()">
    <i class="cc-icon cc-icon-chat" aria-hidden="true"></i>
    <span i18n>Chat with us</span>
  </button>
  <a
    class="cta-button email-button"
    href="mailto:info@sitemate.com?subject=Upgrade%20Subscription - Unlock more properties"
    role="button"
  >
    <i class="cc-icon cc-icon-send" aria-hidden="true"></i>
    <span i18n>Email us</span>
  </a>
</section>
